module.exports = __webpack_public_path__ + "static/media/Roboto-Regular.90679e0c.ttf";